import { Button, Grid } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CaretRight from "../../assets/images/icons/CaretRight";
import { CoachList, Title } from "../../components";
import { H2, P1 } from "../../components/NormalFonts";
import { useLayout } from "../../context/LayoutContext";
import { useGetCoaches } from "../../hooks/Coach/coach.hooks";
import { Banner, FilterBar, PromotionBanner } from "./components";
import styles from "./styles.module.scss";

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { getContentPadding } = useLayout();
  const navigate = useNavigate();

  const { data: coaches } = useGetCoaches({ limit: 10, branch_id: "1" }, {});

  const getMarginTop = () => {
    if (screens.xxl) return "28px";
    if (screens.xl) return "28px";
    if (screens.lg) return "28px";
    if (screens.md) return "28px";
    if (screens.sm) return "-83px";
    return "-106px"; // Default for xs or smaller
  };

  return (
    <div className={styles.homeContainer}>
      <div className={styles.bannerContainer}>
        <Banner />
        <FilterBar />
        <div
          className={`${styles.titleContainer} ${
            screens.xs ? styles.mobile : ""
          }`}
        >
          <H2
            weight="heavy"
            color="#fff"
            className={`${styles.bannerTitle} ${
              screens.lg ? "" : styles.mobile
            }`}
          >
            <Trans
              i18nKey={
                screens.lg ? "home.banner.title" : "home.banner.title.short"
              }
            />
          </H2>
          {screens.lg ? (
            <P1
              weight="medium"
              color="#223A60"
              className={styles.bannerSubTitle}
            >
              <Trans i18nKey={"home.banner.subtitle"} />
            </P1>
          ) : null}
        </div>
      </div>
      <div
        className={styles.promotionBannerContainer}
        style={{ marginTop: getMarginTop() }}
      >
        <PromotionBanner />
      </div>
      <div
        className={`${styles.contentWrapper} ${
          screens.sm ? "" : styles.mobile
        }`}
        style={{ padding: getContentPadding() }}
      >
        <div className={styles.border} />
        <div
          className={`${styles.titleWrapper} ${
            screens.sm ? "" : styles.mobile
          }`}
        >
          <Title
            title={t("home.coach.title")}
            subtitle={t("home.coach.subtitle")}
          />
          {screens.sm ? (
            <Button
              type="link"
              iconPosition={"end"}
              onClick={() => navigate("/trainers")}
              style={{ padding: 0 }}
              icon={
                <CaretRight style={{ fontSize: 24, color: "var(--primary)" }} />
              }
            >
              {t("home.coach.more")}
            </Button>
          ) : null}
        </div>

        <div
          className={`${styles.coachContainer} ${
            screens.sm ? "" : styles.mobile
          }`}
        >
          <CoachList coachList={coaches} />
        </div>
      </div>
    </div>
  );
};

export default Home;
